// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1JuFH","resendInfoText":"OnGoingPaymentBox_resendInfoText__2vz2Z"};